/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredCertificateDtoTimeToExpirationDuration,
    MonitoredCertificateDtoTimeToExpirationDurationFromJSON,
    MonitoredCertificateDtoTimeToExpirationDurationFromJSONTyped,
    MonitoredCertificateDtoTimeToExpirationDurationToJSON,
} from './MonitoredCertificateDtoTimeToExpirationDuration';

/**
 * 
 * @export
 * @interface MonitoredCertificateDtoTimeToExpirationUnits
 */
export interface MonitoredCertificateDtoTimeToExpirationUnits {
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpirationUnits
     */
    dateBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpirationUnits
     */
    timeBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpirationUnits
     */
    durationEstimated?: boolean;
    /**
     * 
     * @type {MonitoredCertificateDtoTimeToExpirationDuration}
     * @memberof MonitoredCertificateDtoTimeToExpirationUnits
     */
    duration?: MonitoredCertificateDtoTimeToExpirationDuration;
}

export function MonitoredCertificateDtoTimeToExpirationUnitsFromJSON(json: any): MonitoredCertificateDtoTimeToExpirationUnits {
    return MonitoredCertificateDtoTimeToExpirationUnitsFromJSONTyped(json, false);
}

export function MonitoredCertificateDtoTimeToExpirationUnitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredCertificateDtoTimeToExpirationUnits {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateBased': !exists(json, 'dateBased') ? undefined : json['dateBased'],
        'timeBased': !exists(json, 'timeBased') ? undefined : json['timeBased'],
        'durationEstimated': !exists(json, 'durationEstimated') ? undefined : json['durationEstimated'],
        'duration': !exists(json, 'duration') ? undefined : MonitoredCertificateDtoTimeToExpirationDurationFromJSON(json['duration']),
    };
}

export function MonitoredCertificateDtoTimeToExpirationUnitsToJSON(value?: MonitoredCertificateDtoTimeToExpirationUnits | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateBased': value.dateBased,
        'timeBased': value.timeBased,
        'durationEstimated': value.durationEstimated,
        'duration': MonitoredCertificateDtoTimeToExpirationDurationToJSON(value.duration),
    };
}

